// extracted by mini-css-extract-plugin
module.exports = {"tabContent":"SalesAgenciesViewer_tabContent__Xma4v","loader":"SalesAgenciesViewer_loader__1vJLP"};